
import '../common/common';

import { shopSdk } from '../graphql/shopClient';

import Lightbox from '../lib/bs5-lightbox';
import { display as showFrequencyChooser } from '../lib/stFrequencyChooser';
import { display as showCompatibilityCheck } from '../lib/stCompatibilityChecker';

import $ from 'jquery';
import { getQueryParams } from '../lib/getQuery';

function setQueryParams(newParams: Record<string, string>) {
  const url = new URL(window.location.href);
  for (const [key, value] of Object.entries(newParams)) {
    if (value) {
      url.searchParams.set(key, value);
    }
  }
  window.history.replaceState({}, '', url.toString());
}

$(function () {
  initializeGallery();
  initializeFrequencyHelper();
  initializeCompatibilityCheck();

  const params = getQueryParams<Record<string, string>>();

  for (const [param, value] of Object.entries(params)) {
    if (!value) continue;
    const $input = $(`#option-${param}-${value}`);
    if ($input.length) {
      $input.prop("checked", true);
    }
  }

  $("section.products").on("change", "select.product-options", function () {
    checkSelected();
  });
  $("section.products").on("click", "input[type=radio]", function () {
    const {selectedOptions, optionNames} = getSelectedOptions();
    const queryParmas = getQueryParams();
    setQueryParams({...queryParmas, ...selectedOptions});
    checkSelected();
  });

  selectSingleOptions();
  checkSelected();
  refreshStock();
});

let lightbox: Record<string, Lightbox> = {};

function initializeGallery() {
  const galleryContainers = $(".galleryContainer");

  for (const galleryContainer of galleryContainers) {
    const id = galleryContainer.id;
    lightbox[id] = new Lightbox(galleryContainer, {
      gallery: id,
      size: "xl",
      constrain: true,
    });
  }

  galleryContainers.on("click", "img", function (e) {
    const index = $(this).data("idx") || 0;
    const galleryId = $(this).closest(".galleryContainer").attr("id");
    if (!galleryId) {
      console.warn("Invalid gallery");
      return;
    }
    lightbox[galleryId].show();
    lightbox[galleryId].carousel?.to(index);
  });
}

function initializeFrequencyHelper() {
  const frequencyHelper = $("#frequencyHelper");
  if (!frequencyHelper.length) {
    return;
  }
  frequencyHelper.on("click", function (e) {
    e.preventDefault();

    showFrequencyChooser().then((selectedAntenna) => {
      // selectedAntenna is the ID of the selected antenna input element,
      // so try to find and check it
      $(`#${selectedAntenna}`).prop("checked", true);
      checkSelected();
    });
  });
}

function initializeCompatibilityCheck() {
  const compatChecker = $("#compatibilityChecker");
  if (!compatChecker.length) {
    return;
  }
  const titleEl = $("#title");
  const antennaType = titleEl.data('prefix');
  let connector1 = compatChecker.data("connector1"); // When connector1 is BNC, treat as BNC-M
  let connector2 = compatChecker.data("connector2"); // When connector2 is BNC, treat as BNC-F
  if (connector2 === 'BNC') {
    connector2 = 'BNC-F';
  }
  compatChecker.on("click", function (e) {
    e.preventDefault();

    showCompatibilityCheck(antennaType || connector1, connector2, window.productSlug || '').then((selectedAntenna) => {
      // selectedAntenna is the ID of the selected antenna input element,
      // so try to find and check it
      $(`#${selectedAntenna}`).prop("checked", true);
      checkSelected();
    });
  });
}

interface Product {
  id: string;
  slug: string;
  updatedAt: string;
  variants: {
    id: string;
    sku: string;
    price: number;
    options: Record<string, string>;
    stockLevel: ProductVariant["stockLevel"];
    digitalProductType: ProductVariant["digitalProductType"];
    externalUrl: ProductVariant["externalUrl"];
    externalVendor: ProductVariant["externalVendor"];
  }[];
}

let currentProduct: Product | null = null;
function updateVariantsFromExternal() {
  if (!currentProduct) {
    return;
  }
  const variantMap = window.productVariants;
  for (const variant of currentProduct.variants) {
    if (!variantMap) { return; } // no product map, forget it
    const sku = variant.sku.toLowerCase();
    if (variantMap?.[sku]) {
      // only update if we already know it exists
      const variantInfo = variantMap[sku];
      variantInfo.price = (variant.price / 100).toFixed(2);
      variantInfo.stockLevel = variant.stockLevel as typeof variantInfo.stockLevel;
      variantInfo.digitalProductType = variant.digitalProductType;
      variantInfo.externalUrl = variant.externalUrl;
      variantInfo.externalVendor = variant.externalVendor;
    }
  }
}


export async function fetchProduct(slug: string) {
  const resp = await shopSdk.ProductSummary({slug: {eq: slug}});
  const product = await resp;

  if (!product?.products?.totalItems) {
    throw new Error(`Could not get stock and pricing information for ${slug}`);
  } else if (product.products.totalItems > 1) {
    throw new Error(`Found more than one product with slug ${slug}`);
  }
  const p = product.products.items[0];
  return {
    id: p.id,
    slug: p.slug,
    updatedAt: p.updatedAt,
    variants: p.variants.map((v) => {
      return {
        id: v.id,
        sku: v.sku,
        price: v.price,
        options: Object.fromEntries(
          v.options.map((o) => [o.group.code, o.code])
        ),
        stockLevel: v.stockLevel,
        digitalProductType: v.customFields?.digitalProductType,
        externalUrl: v.customFields?.externalProductInfo?.url,
        externalVendor: v.customFields?.externalProductInfo?.vendor,
      };
    }),
  } as Product;
}

async function refreshStock() {
  if (!window.productSlug) { return; }

  currentProduct = await fetchProduct(window.productSlug);
  updateVariantsFromExternal();
  checkSelected();
}

function getStockClass(stockLevel: ProductVariant['stockLevel']) {
  if (stockLevel === void 0) { return ''; }
  if (stockLevel === '10') {
    return "success";
  } else if (stockLevel === "Backordered" || stockLevel === "unavailable") {
    return "danger";
  }
  return "warning";
}

function getStockMessage(stockLevel: ProductVariant['stockLevel']) {
  if (stockLevel === void 0) { return ''; }
  if (stockLevel === '10') {
    return "In stock";
  } else if (stockLevel === "Backordered") {
    return "Ships in 1–2 weeks";
  } else if (stockLevel === "unavailable") {
    return "Unavailable";
  }
  return `${stockLevel} left`;
}

function updateColorButtons(band: string) {
  for (const variant of Object.values(window.productVariants || {})) {
    if (variant.band.code !== band) {
      continue;
    }
    const price = getPrice(variant, false);

    const labelEl = $(`#option-color-${variant.color.code}-lbl`);
    const nameAndPrice = `${variant.color.name} - ${price}`;
    const stockLevel = `<br /><span class="text-small text-${getStockClass(variant.stockLevel)}">${getStockMessage(variant.stockLevel)}</span>`;
    const isDigitalOrExternal = variant.digitalProductType || variant.externalUrl || variant.externalVendor;
    labelEl.html(nameAndPrice + (isDigitalOrExternal ? '' : stockLevel));
  }
}
function updateButtonStockLevels() {
  const selectedOptions = getSelectedOptions().selectedOptions;
  // First find all option groups
  const optionGroups = $('.optionRoot');
  const optionCount = optionGroups.length;

  let filter: Record<string, string> = {};
  for (let i = 0; i < optionCount; i++) {
    const optionGroup = optionGroups[i];
    const optionCode = optionGroup.dataset.optionCode!;
    const isLast = i === optionCount - 1;

    if (!isLast) {
      filter[optionCode] = selectedOptions[optionCode] as any;
    } else {
      const variants = Object.values(window.productVariants || {}).filter((v) => {
        for (const [code, value] of Object.entries(filter)) {
          if (code in v && (v as any)[code] !== value) {
            return false;
          }
        }
        return true;
      });

      const buttons = $(optionGroup).find("label.optionBtn");
      for (const btn of buttons) {
        const optValue = btn.dataset.optionValue!;
        const optValueName = btn.dataset.optionName!;

        const variant = variants.find((v) => v[optionCode as keyof typeof v]?.code === optValue);
        if (!variant) {
          continue;
        }
        const price = getPrice(variant, false);
        const nameAndPrice = `${optValueName} - ${price}`;
        const stockLevel = `<br /><span class="text-small text-${getStockClass(variant.stockLevel)}">${getStockMessage(variant.stockLevel)}</span>`;
        const isDigitalOrExternal = variant.digitalProductType || variant.externalUrl || variant.externalVendor;
        btn.innerHTML = nameAndPrice + (isDigitalOrExternal ? '' : stockLevel);
      }
    }
  }
}
function formatPriceRange(min: number, max: number) {
  if (min === max) {
    return `$${min.toFixed(2)}`;
  }
  return `$${min.toFixed(2)} - $${max.toFixed(2)}`;
}

function getPrice(variantToShow: AntennaProductVariant, showOriginal = true) {
  const price = parseFloat(variantToShow.price);
  const discountPrice = parseFloat(variantToShow.discountprice || variantToShow.price);
  if (!showOriginal || price === discountPrice) {
    return `$${discountPrice.toFixed(2)}`;
  } else {
    return `$${discountPrice.toFixed(2)} <s class="price">$${price.toFixed(2)}</s>`;
  }
}

function showVariant(sku: string) {
  const variantMap = window.productVariants;
  const variantToShow = variantMap?.[sku];
  if (!variantToShow) {
    // Iterate over variants, find the highest and lowest prices
    let maxPrice = 0;
    let maxDiscountPrice = 0;
    let minPrice = Infinity;
    let minDiscountPrice = Infinity;
    for (const variant of Object.values(variantMap || {})) {
      const price = parseFloat(variant.price);
      const discountPrice = parseFloat(variant.discountprice || variant.price);
      if (price > maxPrice) {
        maxPrice = price;
      }
      if (discountPrice > maxDiscountPrice) {
        maxDiscountPrice = discountPrice;
      }
      if (price < minPrice) {
        minPrice = price;
      }
      if (discountPrice < minDiscountPrice) {
        minDiscountPrice = discountPrice;
      }
    }
    // format the price range. If the discount price is different than the regular price then
    // show both formatted like "minDiscountPrice - maxDiscountPrice <s class="price">minPrice - maxPrice</s>"
    let priceRange = formatPriceRange(minPrice, maxPrice);
    if (minDiscountPrice !== minPrice || maxDiscountPrice !== maxPrice) {
      priceRange = `${formatPriceRange(minDiscountPrice, maxDiscountPrice)} <s class="price">${ formatPriceRange(minPrice, maxPrice) }</s>`;
    }
    $("#display-price").html(priceRange);
  } else {
    const stockLevel = variantToShow.stockLevel;
    $("#stocklevel-display")
      .removeClass("bg-success bg-warning bg-danger")
      .addClass(`bg-${getStockClass(stockLevel)}`)
      .text(getStockMessage(stockLevel));

    $("#display-price").html(getPrice(variantToShow));
    if (stockLevel === 'unavailable') {
      $("#unavailableNotice").removeClass('d-none');
      $("#backorderNotice").addClass('d-none');
      $("#shippingNotice").addClass('d-none');
      $(".variant-buttons").addClass('disabled').prop('disabled', true).text('Unavailable');
    } else if (stockLevel === 'Backordered') {
      $("#unavailableNotice").addClass('d-none');
      $("#backorderNotice").removeClass('d-none');
      $("#shippingNotice").addClass('d-none');
      $(".variant-buttons").removeClass('disabled').prop('disabled', false).text('Add To Cart');
    } else {
      $("#unavailableNotice").addClass('d-none');
      $("#backorderNotice").addClass('d-none');
      $("#shippingNotice").removeClass('d-none');
      $(".variant-buttons").removeClass('disabled').prop('disabled', false).text('Add To Cart');
    }
  }
}


function isSelect(element: HTMLElement): element is HTMLSelectElement {
  return element.tagName === "SELECT";
}

const displayMap = {
  'st-sma-f': "SMA Female",
  'st-sma-m': "SMA Male",
  'st-bnc': "BNC (Male)",
};
function formatColor(color: string) {
  if (color === "Glow") {
    return "Glow In The Dark";
  } else {
    return color;
  }
}

function getSelectedOptions() {
  const productOptions: JQuery<HTMLSelectElement | HTMLDivElement> = $(".product-options");
  const selectedOptions: Record<string, string> = {};
  const optionNames: Record<string, string> = {};
  if (productOptions.length) {
    for (const optionSelect of productOptions) {
      if (isSelect(optionSelect)) {
        const optionCode = optionSelect.getAttribute("data-option-code");
        const optionValue = optionSelect.value;
        selectedOptions[optionCode!] = optionValue;
      } else {
        // This is a radio button group
        const optionCode = optionSelect.getAttribute("data-option-code");
        const optionValue = $(optionSelect).find("input:checked").val();
        const optionName = $(optionSelect).find("input:checked").attr("data-option-name");
        optionNames[optionCode!] = optionName || '';
        selectedOptions[optionCode!] = optionValue as string;
      }
    }
  }

  return {selectedOptions, optionNames};
}

function selectSingleOptions() {
  // for each option group, if there is only one option, select it
  const productOptions: JQuery<HTMLSelectElement | HTMLDivElement> = $(".product-options");
  const selectedOptions: Record<string, string> = {};
  const optionNames: Record<string, string> = {};
  if (productOptions.length) {
    for (const optionSelect of productOptions) {
      if (isSelect(optionSelect)) {
        const numOptions = optionSelect.options.length;
        if (numOptions === 1) {
          optionSelect.selectedIndex = 0;
        }
      } else {
        // This is a radio button group
        const numOptions = $(optionSelect).find("input").length;
        if (numOptions === 1) {
          $(optionSelect).find("input").prop("checked", true);
        }
        // const optionCode = optionSelect.getAttribute("data-option-code");
        // const optionValue = $(optionSelect).find("input:checked").val();
        // const optionName = $(optionSelect).find("input:checked").attr("data-option-name");
        // optionNames[optionCode!] = optionName || '';
        // selectedOptions[optionCode!] = optionValue as string;
      }
    }
  }
}

function checkSelected() {

  const {selectedOptions, optionNames} = getSelectedOptions();

  $("#subtitle").html(optionNames['band'] || "&nbsp;");
  const titleEl = $("#title");
  const pageSlug = titleEl.data("slug");
  const pageDisplay = displayMap[pageSlug as keyof typeof displayMap];

  const variantButtons = $(".variant-buttons");
  if ('band' in selectedOptions && 'color' in selectedOptions) {
    // Special handling for the Super-Elastic Signal Stick product; hide the color options until a band is selected,
    // and then only show the colors that are available for that band
    const band = selectedOptions['band'];
    if (!band) {
      // No band selected; hide all the color options
      $("div.option-color").slideUp();
    } else {
      // Update the button labels
      updateColorButtons(band);

      const colorOptions = $("div.option-color");
      colorOptions.slideDown();

      const foundColors: string[] = [];
      for (const variantBtn of variantButtons) {
        const curBand = variantBtn.getAttribute("data-item-band");
        if (curBand === band) {
          foundColors.push(variantBtn.getAttribute("data-item-color")!);
        }
      }

      const colorRadios = colorOptions.find("input[type=radio]") as JQuery<HTMLInputElement>;
      for (const radioBtn of colorRadios) {
        const color = radioBtn.getAttribute("value")!;
        if (foundColors.includes(color)) {
          $(radioBtn).removeClass('d-none');
          colorOptions.find(`#${radioBtn.id}-lbl`).removeClass('d-none');
        } else {
          $(radioBtn).addClass('d-none');
          colorOptions.find(`#${radioBtn.id}-lbl`).addClass('d-none');
        }
      }
    }
  } else {
    // There may be one or more options defined for this product; we need to find them and
    // update the stock levels
    updateButtonStockLevels();
  }

  const colorValid = $(`#option-color-${selectedOptions['color']}-lbl`).is(":visible");
  titleEl.text(`${pageDisplay} ${colorValid ? `- ${formatColor(optionNames['color'])}` : ''}`);

  let foundSKU = "";
  // Find the variant that matches the selected options; do that by looking at the add to cart buttons
  for (const variantBtn of variantButtons) {
    let matches = true;
    const sku = variantBtn.getAttribute("data-item-sku");
    for (const [code, value] of Object.entries(selectedOptions)) {
      const optionValue = variantBtn.getAttribute(`data-item-${code}`);
      if (optionValue !== value) {
        matches = false;
        break;
      }
    }
    const relevantElements = $(`.${sku!.toLowerCase()}`);
    if (!matches) {
      // Hide everything associated with this sku
      relevantElements.addClass('d-none');
    } else {
      foundSKU = sku!;
      relevantElements.removeClass('d-none');
    }
  }
  showVariant(foundSKU.toLowerCase()); // Update price and stock levels
  if (foundSKU) {
    $(".main-toggled").addClass('d-none');
  } else {
    $(".main-toggled").removeClass('d-none');
  }
}
